import React, { useState, useEffect, useRef } from 'react';
import AlertAlgo from '../controls/AlertSnack'
import { withNamespaces } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import { log } from '../../actions/error'
import Button from 'react-bootstrap-button-loader';
import * as storage from '../../utils/storage'
import Switch from '@material-ui/core/Switch'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

import { unsubscribe } from '../../actions/notification';
import * as StatusCode from '../../scripts/StatusCode';

const useStyles = makeStyles(theme => ({
    link: {
        display: 'table',
        width: '100%',
        fontSize: '12px',
        marginTop: '10px',
    },
    div: {
        display: 'block !important'
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function NotificationSettings(prosp) {
    const classes = useStyles();
    const [hasSubscription, setHasSubscription] = useState(false);
    const [error, setError] = useState(false);
    const [showNotification, setShowNotification] = useState(storage.getShowSubscribe() ?? true);
    const [openConfirmUnsubscribe, setOpenConfirmUnsubscribe] = useState(false);
    const [isNotificationSupported, setIsNotificationSupported] = useState(true);

    const alertRef = useRef(null);

    useEffect(() => {
        check();
        verifySubscription();
    }, [])

    const check = () => {
        if (!('serviceWorker' in navigator)) {
            setIsNotificationSupported(false);
        }
        if (!('PushManager' in window)) {
            setIsNotificationSupported(false);
        }
    }

    const verifySubscription = () => {
        // Check if the device has already a subscription
        navigator.serviceWorker.ready.then((reg) => {
            reg.pushManager.getSubscription().then((subscription) => {
                setHasSubscription(subscription !== null);
            });
        });
    }

    const handleUnsubscribe = () => {
        navigator.serviceWorker.ready.then((reg) => {
            reg.pushManager.getSubscription().then((subscription) => {
                subscription
                    .unsubscribe()
                    .then((successful) => {
                        unsubscribe(subscription.endpoint).then(response => {
                            if (response != null && response.status == StatusCode.STATUS_OK) {
                                setHasSubscription(false);
                                handleCloseConfirmUnsubscribe();
                                showMessageSuccess(i18next.t('pushNotification:successUnsubscribedMessage'));

                            } else {
                                showMessageError(i18next.t('error:generic-error'));
                            }
                        })
                    })
                    .catch((e) => {
                        // Unsubscribing failed
                        showMessageError(i18next.t('error:generic-error'));
                    });
            });
        });
    }

    const onChangeShowNotification = (event) => {
        setShowNotification(event.target.checked);
        storage.saveShowSubscribe(event.target.checked);
    }

    const handleOpenConfirmUnsubscribe = (id) => {
        setOpenConfirmUnsubscribe(true);
    }

    const handleCloseConfirmUnsubscribe = () => {
        setOpenConfirmUnsubscribe(false);
    }

    const showMessageSuccess = (message) => {
        alertRef.current.showMessageSuccess(message);
    }

    const showMessageError = (msg) => {
        alertRef.current.showMessageError(msg);
    }

    return (
        <div style={{ marginTop: '20px' }}>
            <div style={{ marginBottom: '20px' }}>
                <span>{i18next.t('pushNotification:form.hasSupportPushNotification')}{i18next.t('common:labelSeparator')} </span>
                <span>{i18next.t(`common:${isNotificationSupported ? 'yes' : 'no'}`)}</span>
            </div>

            <FormControl>
                <FormControlLabel
                    control={
                        <Switch
                            checked={showNotification}
                            onChange={onChangeShowNotification}
                            name="partialLeave"
                            variant="success"
                        />
                    }
                    label={i18next.t("pushNotification:form.showPopupSubscribe")}
                    labelPlacement="start"
                />
            </FormControl>

            {hasSubscription && <FormControl className={classes.div}>
                <Button onClick={handleOpenConfirmUnsubscribe} variant="danger">
                    {i18next.t("pushNotification:form.unsubscribe")}
                </Button>
            </FormControl>}

            <Dialog
                open={openConfirmUnsubscribe}
                onClose={handleCloseConfirmUnsubscribe}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title">
                    Confirmation
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {i18next.t('pushNotification:confirmUnsubscribe')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirmUnsubscribe} color="primary" variant="success">
                        {i18next.t('buttons:no')}
                    </Button>
                    <Button autoFocus onClick={() => handleUnsubscribe()} color="primary" variant="success">
                        {i18next.t('buttons:yes')}
                    </Button>
                </DialogActions>
            </Dialog>

            <AlertAlgo ref={alertRef} />

        </div >
    )
}

export default withNamespaces(['error', 'pushNotification', 'buttons', 'error', 'common'], { wait: true })(NotificationSettings);